import React from 'react';
import ArticlesListView from "../features/articles/views/articles-list-view";
import PreviewArticleModal from "../features/articles/components/preview-article-modal";
import DeleteArticleModal from "../features/articles/components/delete-article-modal";
import UniversalArticleDeleteInfoModal from "../features/articles/components/universal-article-delete-info-modal";
import ArticleToPrintModal from "../features/articles/components/article-to-print-modal";
import ArticleQrInfoModal from "../features/articles/components/article-qr-info-modal";
import ShareArticleModal from "../features/articles/components/share-article-modal";
import ConvertDocumentAiModal from "../features/articles/components/convert-document-ai-modal";
import AiErrorResponseModal from "../features/articles/components/ai-error-response-modal";
import PublishArticleModal from "../features/articles/components/publish-article-modal";

const ArticlesPage: React.FC = () => {
    return (
        <div className="w-full max-h-full overflow-y-auto">
            <div className="px-6 py-[80px] max-w-[848px] mx-auto">
                <ArticlesListView/>
            </div>
            <PreviewArticleModal titleBackButton="Powrót do listy" showEditAction={true}/>
            <ArticleToPrintModal/>
            <ArticleQrInfoModal/>
            <DeleteArticleModal/>
            <PublishArticleModal/>
            <UniversalArticleDeleteInfoModal/>
            <ShareArticleModal/>
            <AiErrorResponseModal/>
            <ConvertDocumentAiModal/>
        </div>
    );
};

export default ArticlesPage;
